import { faHeadphones } from "@fortawesome/fontawesome-free-solid";
import {
  faBookOpen,
  faMicrophone,
  faPenRuler,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaBookmark } from "react-icons/fa";
import grammar_ar from "../../../assets/arabic/books/arabic_grammar_books.png";
import academic_ar from "../../../assets/arabic/books/arabiya_books.png";
import quranic_ar from "../../../assets/arabic/books/madina_books.png";
import hr_2 from "../../../assets/icons/2hr.png";
import partyFlag from "../../../assets/partyFlag.png";
import NextBatchRegCard from "./../../CourseRegistration/NextBatchRegCard";
import RegisterNow from "./../../utils/RegisterNow";
import ArabicCourseLevels from "./ArabicCourseLevels";
import ArabicCourseTeacher from "./ArabicCourseTeacher";
import ArabicFAQs from "./ArabicFAQs";
import ArabicSchedule from "./ArabicSchedule";

const ArabicInfo = () => {
  // const level_data = {
  //   level_0: [
  //     "১ মাসের কোর্স",
  //     "আরবি বর্ণমালা",
  //     "আরবি হাতের লেখা",
  //     "সর্বনাম",
  //     "ইশারার শব্দ",
  //     "৩০টি প্রয়োজনীয় শব্দ",
  //     "রঙের নাম",
  //     "সাপ্তাহিক দিনের নাম",
  //     "মাসের নাম",
  //     "সংখ্যা ১-১০০০",
  //     "কিছু সূরার অনুবাদ",
  //     "৭০+ দৈনন্দিন কথোপকথন",
  //   ],
  //   level_1: [
  //     "৩ মাসের কোর্স",
  //     "মদিনা বুক ১ম খন্ড সম্পূর্ণ ",
  //     "২৩ টি অধ্যায় / ১২৩ পৃষ্ঠা",
  //     "প্রি-রেকর্ডেড লেকচার",
  //     "লাইভ ক্লাস ও প্রশ্নত্তোর",
  //     "পুরুষ - মহিলা আলাদা ক্লাস",
  //     "লাইভ ক্লাস রেকর্ড",
  //     "এসাইনমেন্ট ও পরীক্ষা",
  //     "আরবিতে ভাইভা",
  //     "সাপোর্ট - টেলিগ্রাম গ্রুপ",
  //     "সার্টিফিকেট",
  //   ],
  //   level_2: [
  //     "৪ মাসের কোর্স",
  //     "মদিনা বুক ২য় খন্ড সম্পূর্ণ",
  //     "৩১ টি অধ্যায় / ২২০ পৃষ্ঠা",
  //     " প্রি-রেকর্ডেড লেকচার",
  //     "লাইভ ক্লাস ও প্রশ্নত্তোর",
  //     "পুরুষ - মহিলা আলাদা ক্লাস",
  //     "লাইভ ক্লাস রেকর্ড",
  //     "এসাইনমেন্ট ও পরীক্ষা",
  //     "আরবিতে ভাইভা",
  //     "সাপোর্ট - টেলিগ্রাম গ্রুপ",
  //     "সার্টিফিকেট",
  //   ],
  //   level_3: [
  //     "৪ মাসের কোর্স",
  //     "মদিনা বুক ৩য় খন্ড সম্পূর্ণ",
  //     "৩৪ টি অধ্যায় / ৩০২ পৃষ্ঠা",
  //     " প্রি-রেকর্ডেড লেকচার",
  //     "লাইভ ক্লাস ও প্রশ্নত্তোর",
  //     "পুরুষ - মহিলা আলাদা ক্লাস",
  //     "লাইভ ক্লাস রেকর্ড",
  //     "এসাইনমেন্ট ও পরীক্ষা",
  //     "আরবিতে ভাইভা",
  //     "সাপোর্ট - টেলিগ্রাম গ্রুপ",
  //     "সার্টিফিকেট",
  //   ],
  // };
  return (
    <div className="container mx-auto px-5 my-10">
      {/* Welcome  */}
      <section>
        <div className="rounded bg-gradient-to-tl from-sky-200 flex justify-between header-card">
          <div className="p-5">
            <p className="text-3xl">আরবি ভাষা কোর্সে</p>
            <p className="text-4xl">স্বাগতম!</p>
          </div>
          <div className="p-5 hidden md:inline">
            <div className="flex justify-between">
              <div className="text-right font-serif align-middle mr-10">
                <p className="text-4xl ">دروس اللغة العربية</p>
                <p className="text-2xl">لغير الناطقين بها </p>
              </div>
              <div>
                <img src={partyFlag} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Descripttion  */}
      <section className="my-10">
        <p className="text-xl">কোর্স পরিচিতিঃ</p>
        <p>
          ইসলাম ধর্মের পবিত্র গ্রন্থ আল-কুরআন এবং হাদিসের মূল ভাষা আরবি। অনুবাদ
          পড়ার চেয়ে সরাসরি আরবি ভাষায় কুরআন বুঝতে পারলে এর ভাব, গভীরতা এবং
          অলংকার সঠিকভাবে উপলব্ধি করা যায়। এছাড়া, তাফসির, হাদিস গ্রন্থ (যেমন:
          বুখারি, মুসলিম), ফিকহ (ইসলামী আইনশাস্ত্র) এবং আকীদার মূল কিতাবগুলো সবই
          আরবি ভাষায় রচিত। সেই সাথে, আরবি একটি অত্যন্ত ব্যাকরণসিদ্ধ ও সমৃদ্ধ
          ভাষা। এটি শেখার মাধ্যমে মানুষের চিন্তা করার ক্ষমতা, শব্দভাণ্ডার এবং
          সাহিত্যবোধ বিকশিত হয়।
        </p>
        <p>
          বর্তমান সময়ে ইসলামের বিভিন্ন বিষয়ের অনেক ভুল বা বিকৃত অনুবাদ ও
          ব্যাখ্যা ইন্টারনেটে বা সমাজে প্রচলিত আছে। আরবি ভাষা জানা থাকলে
          অপব্যাখ্যাগুলো সহজেই ধরে ফেলা যায় এবং সঠিক ইসলামের ওপর অবিচল থাকা যায়।
        </p>
      </section>

      <section className="my-10 md:my-32 md:flex  justify-around items-center">
        <div>
          <img className="" src={hr_2} alt="" />
        </div>
        <div className="my-10 md:my-0">
          <p className="text-xl">দৈনিক অধ্যয়নের সময়</p>
          <p>কোর্সটি ভালোভাবে শেষ করতে হলে আপনাকে প্রতিদিন ২ ঘন্টা পড়তে হবে।</p>
          <p>
            যেদিন ১ ঘন্টা লাইভ ক্লাস থাকবে, সেদিনও ক্লাসের বাইরে আপনাকে ১ ঘন্টা
            পড়তে হবে।
          </p>
        </div>
      </section>

      {/* study method  */}
      <section className="my-10">
        <p className="text-xl">শিখন পদ্ধতিঃ</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 my-5">
          <div className="text-center bg-green-200 px-5 py-10 rounded learning_method_card">
            <FontAwesomeIcon
              className="text-3xl text-green-700"
              icon={faHeadphones}
            />
            <p className="text-2xl text-green-700 mt-3 mb-5">লিসনিং</p>
            <p className="text-left px-5">
              আমরা মাতৃভাষা যেভাবে শিখি—প্রথমে শুনে শুনে, পরে বলতে শিখি, আরবি
              ভাষা শেখার ক্ষেত্রেও এই নিয়মটি সবচেয়ে কার্যকর। শুধু ব্যাকরণ মুখস্থ
              করে সাবলীলভাবে কথা বলা যায় না, আরবরা কিভাবে বলে, কিভাবে উচ্চারণ
              করে শুনতে হবে। কোর্সে শুধুমাত্র শুদ্ধ আরবি শেখানো হবে, আঞ্চলিক
              ভাষা নয়।
            </p>
          </div>
          <div className="text-center bg-violet-200 px-5 py-10 rounded learning_method_card">
            <FontAwesomeIcon
              className="text-3xl text-violet-700"
              icon={faBookOpen}
            />
            <p className="text-2xl text-violet-700 mt-3 mb-5">রিডিং</p>

            <p className="text-left px-5">
              রিডিং শুধু ভাষা শেখার গতিই বাড়িয়ে দেয় না, বরং শব্দভাণ্ডার সমৃদ্ধ
              করতে এবং ব্যকরনের প্রয়োগ শিখতেও সাহায্য করে। এভাবে আরবি ভাষা হরকত
              ছাড়া (দম্মা-ফাতহা-কাসরা) ছাড়া পড়তে শেখা যায়। বেশি বেশি পড়লে চোখের
              দেখা বানানগুলো মুখস্থ হয়ে যায়। ফলে লেখার সময় বানান ভুল হওয়ার
              সম্ভাবনা কমে যায়।
            </p>
          </div>
          <div className="text-center bg-red-200 px-5 py-10 rounded learning_method_card">
            <FontAwesomeIcon
              className="text-3xl text-rose-700"
              icon={faPenRuler}
            />
            <p className="text-2xl text-rose-700 mt-3 mb-5">রাইটিং</p>
            <p className="text-left px-5">
              নিজের অনুভূতি, মতামত বা কোনো বিষয়ের গভীর বিশ্লেষণ সুন্দরভাবে
              ফুটিয়ে তোলার জন্য লেখার দক্ষতা থাকা প্রয়োজন। ব্যকরনের নিয়ম মেনে
              লিখতে জানলে মাথায় গোছানো চিন্তা তৈরি হয় এবং ভাষার ওপর নিখুঁত দখল
              আসে। ক্লাসে নিয়মিত লিখিত এসাইনমেন্ট ও পরীক্ষার মাধ্যমে
              শিক্ষার্থীদের লেখার দক্ষতা বাড়ানো হবে।
            </p>
          </div>
          <div className="text-center bg-yellow-200 px-5 py-10 rounded learning_method_card">
            <FontAwesomeIcon
              className="text-3xl text-orange-700"
              icon={faMicrophone}
            />
            <p className="text-2xl text-orange-700 mt-3 mb-5">স্পিকিং</p>
            <p className="text-left px-5">
              আরবিতে কথা বলার দক্ষতা অর্জন করতে হলে শুধু পড়া বা লেখা নয়, নিয়মিত
              কথা বলার অনুশীলনও প্রয়োজন। কোর্সে দরকারী ছোট ছোট বাক্য দিয়ে শুরু
              করে ধীরে ধীরে বড় বাক্য গঠন করতে শেখানো হবে। গ্রুপ স্টাডির মাধ্যমে
              শিক্ষার্থীরা একে অপরের সঙ্গে কথা বলার অনুশীলন করতে পারবে। কোর্সে
              মৌখিক পরীক্ষা নেওয়া হবে।
            </p>
          </div>
        </div>
      </section>

      {/* register now  */}
      <section>
        <RegisterNow course="arabic"></RegisterNow>
      </section>
      <section className="my-10 ">
        <p className="text-xl">কোর্সের ধরণঃ</p>

        <section className="my-10 md:my-20  grid md:grid-cols-3  justify-around items-center">
          <div>
            <img src={academic_ar} alt="" srcSet="" />
          </div>
          <div className="my-10 md:col-span-2 md:mx-16">
            <p className="">একাডেমিক আরবি</p>
            <p className="text-xl mb-10 flex items-center gap-2">
              <FaBookmark className="text-slate-400" />
              <span>আল আরাবিয়্যাতু বাইনা ইয়াদাইক</span>
            </p>
            <p>
              আরবি ভাষা শেখার জন্য বর্তমানে সবচেয়ে জনপ্রিয় সিরিজ এটি। এই সিরিজে
              মোট ৪টি খন্ড আছে, প্রতি খন্ডে ২টি করে বই আছে। অর্থাৎ মোট ৮টি বই।
            </p>
            <p>
              এটি মূলত সৌদি আরবের রিয়াদভিত্তিক প্রতিষ্ঠান ‘العربية للجميع’ (সবার
              জন্য আরবি) - এর তত্ত্বাবধানে বিশিষ্ট আরবি ভাষা বিশেষজ্ঞদের একটি দল
              প্রস্তুত করেছে। বর্তমানে সৌদি আরবের প্রায় সব বিশ্ববিদ্যালয়ে এই
              সিরিজের বই ব্যবহার করে আরবি ভাষা শেখানো হয়।
            </p>
            <p>
              এই সিরিজের বইগুলো ইংরেজি ভাষার IELTS বা আধুনিক আন্তর্জাতিক কাঠামোর
              সাথে তুলনা করা যায়। লিসনিং, রিডিং, স্পিকিং ও রাইটিং - এই চারটির
              ওপর সমানভাবে জোর দিয়ে সাজানো হয়েছে।
            </p>
            <p className="pt-3">
              যারা মধ্যপ্রাচের (যেমন - সৌদি আরব, আরব আমিরাত, মিসর ইত্যাদি) কোন
              বিশ্ববিদ্যালয়ে (যেমন মদিনা বিশ্ববিদ্যালয়) পড়াশোনা করতে চায়, তাদের
              জন্য এই সিরিজটি অত্যন্ত উপকারী হবে, ইনশাআল্লাহ।
            </p>
          </div>
        </section>

        <section className="my-10 md:mx-16">
          <ArabicSchedule course={"academic_ar"} title={"একাডেমিক আরবি"} />
        </section>
        <section className="my-20 md:mx-16">
          <div>
            <div className="text-xl my-10 font-medium">লেভেল সমূহঃ</div>
            <div>
              <ArabicCourseLevels
                course={"academic_ar"}
                title={"একাডেমিক আরবি"}
              />
            </div>
          </div>
        </section>

        <section className="my-10 md:my-20  grid md:grid-cols-3  justify-around items-center">
          <div className="my-10 md:mb-32 order-2 md:col-span-2 md:mx-16">
            <p className="">কুরআন-হাদিসের আরবি</p>
            <p className="text-xl mb-10 flex items-center gap-2">
              <FaBookmark className="text-slate-400" />
              <span>দুরুসুল লুগাহ আল আরাবিয়্যাহ</span>
            </p>
            <p>
              এই সিরিজে ৩টি খন্ড রয়েছে, যা বিশ্বজুড়ে ‘মদিনা বুক’ নামে বেশি
              পরিচিত, অনারবদের জন্য আরবি ভাষা শেখার অন্যতম প্রাচীন, জনপ্রিয় এবং
              মানসম্মত একটি সিলেবাস । এই বইয়ের প্রধান বৈশিষ্ট্য হলো, এর মাধ্যমে
              কুরআনে ব্যবহৃত আরবি শব্দ ও বাক্য কাঠামোর সাথে শিক্ষার্থীরা খুব
              সহজেই পরিচিত হতে পারে । মদিনা ইসলামী বিশ্ববিদ্যালয়ের শিক্ষক,
              প্রখ্যাত আলেম ড. ভি. আবদুর রহিম এটি লিখেছিলেন। দীর্ঘদিন ধরে মদিনা
              ইসলামী বিশ্ববিদ্যালয়সহ বিশ্বের নানা দেশের মাদরাসা, স্কুল ও শিক্ষা
              প্রতিষ্ঠানে অনারবদের প্রাথমিক আরবি শিক্ষার মূল সিলেবাস হিসেবে এটি
              পড়ানো হয়ে আসছে। এছাড়া শুদ্ধ আরবিতে কথা বলা শিখতে এই বইয়ের
              অধ্যায়গুলো খুবই মানসম্মত।
            </p>
            <p>
              যারা কুরআন-হাদিসের মূল আরবি ভাষা শিখতে চান, মসজিদে নববীর খুতবা,
              আরব শায়খদের আরবি লেকচার বুঝতে চান, তাদের জন্য ভালো অপশন হতে পারে
              এই সিরিজটি, ইনশাআল্লাহ।
            </p>
          </div>
          <div className="order-1 md:order-3">
            <img src={quranic_ar} alt="" srcSet="" />
          </div>
        </section>

        <section className="my-10 md:mx-16">
          <ArabicSchedule course={"madina_ar"} title={"মদিনা বুক"} />
        </section>
        <section className="my-20 md:mx-16">
          <div>
            <div className="text-xl my-10 font-medium">লেভেল সমূহঃ</div>
            <div>
              <ArabicCourseLevels course={"madina_ar"} title={"মদিনা বুক"} />
            </div>
          </div>
        </section>

        <section className="my-10 md:my-20 grid md:grid-cols-3  justify-around items-center">
          <div>
            <img src={grammar_ar} alt="" srcSet="" />
          </div>
          <div className="my-10 md:my-32 md:col-span-2 md:mx-16">
            <p className="">আরবি ব্যকরণ</p>
            <p className="text-xl mb-10 flex items-center gap-2">
              <FaBookmark className="text-slate-400" />
              <span>সরফ ও নাহু</span>
            </p>
            <p>
              একটি ভাষার প্রাণ হলো ব্যকরণ। আর ব্যকরন শুধু জানলেই হবে না,
              ব্যবহারও জানতে হবে। এই বিশেষ কোর্সে আরবি ব্যকরনের মৌলিক কিছু বই
              পড়ান হবে। আরবি শব্দ কিভাবে রূপান্তরিত হয়, কিভাবে অর্থ পরিবর্তিত
              হয়, কিভাবে একটি শব্দ অন্যকে প্রভাবিত করে ও পরিবর্তন করে - এই
              বিষয়গুলো শিখবেন এই কোর্সে। ভাষা শেখার জন্য শুরুতে ব্যকরন শেখা কঠিন
              হতে পারে, তবে আপনি যদি ইতিমধ্যে কিছুটা আরবি জানেন, তবে এই কোর্সে
              ব্যকরন শেখার মাধ্যমে ভাষার আরো গভীরে প্রবেশ করতে পারবেন,
              ইনশাআল্লাহ।
            </p>
            <p></p>
          </div>
        </section>
        <section className="my-10 md:mx-16">
          <ArabicSchedule course={"grammar_ar"} title={"আরবি ব্যকরণ"} />
        </section>
        <section className="my-20 md:mx-16">
          <div>
            <div className="text-xl my-10 font-medium">লেভেল সমূহঃ</div>
            <div>
              <ArabicCourseLevels course={"grammar_ar"} title={"আরবি ব্যকরণ"} />
            </div>
          </div>
        </section>
      </section>

      {/* <CardArabicNextBatch /> */}
      <NextBatchRegCard course="arabic" />

      {/* FAQs  */}
      <ArabicFAQs />

      {/* <section className='my-3 lg:w-1/3 mx-auto'>
                <Link to="/registration-arabic"><p className='p-3 bg-yellow-200 rounded shadow-md'>বিকাশ নাম্বার এবং গ্রুপ লিংক এখানে <FontAwesomeIcon className='text-orange-600' icon={faMousePointer} fade/></p></Link>
            </section> */}

      {/* Course Teacher  */}
      <ArabicCourseTeacher />
    </div>
  );
};

export default ArabicInfo;
